var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('YY-head'),_c('y-search',{attrs:{"logo":_vm.yyLogo,"tabShow":true},on:{"searchData":_vm.toSearch}}),_c('y-y-menu'),_c('service-box'),_c('provider-list'),_c('demand-list'),_c('information-box'),_c('search-box')],1)}
var staticRenderFns = []

export { render, staticRenderFns }